module.exports = __webpack_public_path__ + "img/qic.576177d2.svg";